/*
NOTE: This is a tweaked version of `FloatingCallout.js`
Updated to support opening a video in a modal
*/

import React, { useState } from 'react';
import ReactPlayer from 'react-player';

import { CustomModal } from '../BrandCampaign/BrandCampaignHero';
import ContentfulImage from '../Common/ContentfulImage';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import PageSection from '../PageSections/PageSection';
import * as styles from './VideoCallout.module.scss';

export default function VideoCallout({ section, wide, shadow, bgOverlap = false, rounded = true }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const imageLeft = section.imageLocation === true;
  const imageBleed = section.imageStyle === 'Bleed';

  return (
    <PageSection
      slim
      className={[styles.container, styles[section.backgroundColor], bgOverlap ? styles.backgroundOverlap : ''].join(
        ' '
      )}
      wide
      data-analytics-section={'floating-callout'}
    >
      <div
        className={[
          styles.floatingCallout,
          wide ? styles.wide : '',
          shadow ? styles.shadow : '',
          rounded ? styles.rounded : '',
        ].join(' ')}
        style={{ '--backgroundImage': `url('${section.backgroundImage?.file?.url}')` }}
      >
        <div
          className={[styles.wrapper, imageBleed ? styles.imageBleed : '', imageLeft ? styles.imageLeft : ''].join(' ')}
        >
          <div className={styles.copy} data-analytics-component={'callout-copy'} data-analytics-id={section.title}>
            {section.subtitle && <div className={styles.subtitle}>{section.subtitle}</div>}
            <h2>{section.title}</h2>
            <button className={styles.modalLauncher} onClick={handleOpen}>
              <RichTextConverter copy={section.copy} />
            </button>
          </div>
          <button className={styles.modalLauncher} onClick={handleOpen}>
            <ContentfulImage
              data-analytics-component={'callout-image'}
              className={styles.videoThumbnail}
              imageFragment={section.mainImage}
              height={section.mainImage.height}
              width={section.mainImage.width}
            />
          </button>
        </div>
      </div>
      <CustomModal open={open} onClose={handleClose}>
        <div data-analytics-component={'brand-video-modal'}>
          <ReactPlayer url={section.wistiaUrl} playing={open} controls={false} width="100%" />
        </div>
      </CustomModal>
    </PageSection>
  );
}
